import { normalize, schema } from 'normalizr';

const appointment = new schema.Entity('appointments');
const chunk = new schema.Entity('chunk', { appointments: [appointment] });
export const normalizeCalendarDay = (data) => normalize(data, [chunk]);
export const normalizeChunk = (data) => normalize(data, chunk);



// WEBPACK FOOTER //
// ./src/store/schemas.js